var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90.207,
    height: 90.207,
    viewBox: "0 0 90.207 90.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M0-682.665H90.207v90.207H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "businessman",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(25.723 2.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M-254.572-127.286a19.381,19.381,0,0,1-19.38,19.381,19.381,19.381,0,0,1-19.381-19.381,19.381,19.381,0,0,1,19.381-19.381A19.381,19.381,0,0,1-254.572-127.286Z",
    transform: "translate(293.333 146.666)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    transform: "translate(11.628 51.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "M-431.484-179.607l1.253,8.243h-66.951l1.253-8.243a32.185,32.185,0,0,1,31.819-27.347h.685A32.216,32.216,0,0,1-431.484-179.607Z",
    transform: "translate(497.181 206.954)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g33",
    transform: "translate(45.104 71.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "M0-108.193v-16.473",
    transform: "translate(0 124.666)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g37",
    transform: "translate(33.937 53.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M-146.612-.1-157.769,17.15-168.936-.117",
    transform: "translate(168.936 0.117)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessman);
export default __webpack_public_path__ + "static/media/businessman.2bd588ac12a05135ed1f7c70bf52a7ae.svg";
export { ForwardRef as ReactComponent };